import { Button, Link, Typography, Stack } from "@mui/material";
import CustomInput from "../../components/CustomInput";

const CustomTextArea = (props) => (
  <textarea
    style={{
      border: "1px solid #ddd",
      width: "100%",
      minHeight: 240,
      padding: 8,
      borderRadius: 8,
      outline: "1px solid #aaa"
    }}
    {...props}
  />
);

export default function FbPixel() {
  return (
    <div
      style={{
        maxWidth: "90%",
        margin: "auto"
      }}
    >
      <Typography variant="h3">Facebook Pixel Integration</Typography>
      <Stack direction="row">
        <Typography mr={1} variant="body1">
          Facebook Pixel ID
        </Typography>
        <small>eg. 123456789012234</small>
      </Stack>
      <CustomInput placeholder="Facebook Pixel ID" />
      <Link href="#">Learn More</Link>
      <br />
      <br />
      <Typography variant="body1">Facebook Pixel Code</Typography>
      <CustomTextArea placeholder="Code to be placed in <head> tag" />
      <Stack direction="row" justifyContent="end">
        <Button sx={{ marginBlock: 2 }} variant="contained">
          Save
        </Button>
      </Stack>
    </div>
  );
}
